import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { FeedEmailData } from '../../mail/components/EmailFeedContent';

export interface JobEmailPreviewProps {
  emails: FeedEmailData[];
  jobId: string;
  onEmailClick: (email: FeedEmailData, e: React.MouseEvent) => void;
}

const JobEmailPreview: React.FC<JobEmailPreviewProps> = ({
  emails,
  jobId,
  onEmailClick,
}) => {
  if (emails.length === 0) {
    return (
      <div className="ms-2 mt-2 text-gray-400 fs-8 fst-italic">
        <i className="fas fa-inbox me-1"></i> No recent emails
      </div>
    );
  }

  return (
    <div
      className="ms-2 mt-2 border-start border-2 border-gray-200 ps-3 pe-2"
      style={{
        maxHeight: '160px',
        overflowY: 'auto',
      }}
    >
      {emails.map((email) => {
        const isOutbound = email.folder === 'sent' || email.emailType === 'sent';
        const senderName = email.from?.[0]?.name || email.from?.[0]?.address || email.sender || 'Unknown';
        return (
          <div
            key={email.id}
            className="d-flex align-items-start gap-2 py-2 cursor-pointer rounded px-2 email-row-hover"
            onClick={(e) => onEmailClick(email, e)}
            style={{ marginLeft: '-0.5rem' }}
          >
            <i className={`fas ${isOutbound ? 'fa-paper-plane text-success' : 'fa-envelope text-primary'} fs-8 mt-1`}></i>
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <div className="d-flex align-items-center gap-2">
                <span className="fw-semibold text-gray-800 text-truncate fs-7" style={{ maxWidth: '200px' }}>
                  {email.subject || '(No subject)'}
                </span>
                {email.linkedJobId === jobId && (
                  <span className="badge badge-light-success fs-9">linked</span>
                )}
              </div>
              <div className="d-flex align-items-center gap-2 text-gray-500 fs-8">
                <span className="text-truncate" style={{ maxWidth: '150px' }}>
                  {isOutbound ? `To: ${email.to?.[0] || 'Unknown'}` : senderName}
                </span>
                <span>•</span>
                <span>{formatDistanceToNow(email.createdAt, { addSuffix: true })}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default JobEmailPreview;
